import { PartState } from '../types';
import { curiousState } from './curious';

/**
 * Pointing left state — Bizy looking left (curious pose) with left arm
 * extended straight out to the left, pointing in that direction.
 */
export const pointingLeftState: PartState = {
	...curiousState,
	arms: [
		// Left arm pointing straight out to the left
		{ d: 'M107 135L90 130C84 128 78 124 74 122L68 119', side: 'left' },
		// Right arm hangs down naturally
		curiousState.arms[1],
	],
};
